import { AlphaZCircleIcon } from './AlphaZCircleIcon';

/**
 * author: Contributors
 * id 1F60D37E-2D88-48D1-A291-D3F59D171E55
 * name alpha-z-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-z-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetZCircleIcon = AlphaZCircleIcon;
export default AlphabetZCircleIcon